import { gql } from "@apollo/client";

export const GET_LIVE = gql`
  query Live($where: LiveWhereInputOne!) {
  live(where:$where) {
      id
      page
      pageName
      detail
      description
      fbLiveId
      pageAccessToken
      isSendNoti
      title
      status
      videoLink
      createdAt
      updatedAt
    	shop{
        id
      }
  }
}
`;

export const GET_LIVES = gql`
  query Lives($where: LiveWhereInput, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
  lives(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
    total
    data {
      id
      page
      pageName
      detail
      description
      fbLiveId
      pageAccessToken
      isSendNoti
      shop {
        id
        name
      }
      title
      status
      videoLink
      createdAt
      updatedAt
    }
  }
}
`;